import { Button, Result } from 'antd'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'

type Props = {
  backTo: string
}

export function DetailNotFound({ backTo }: Props) {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <Result
      status="404"
      title={t('common.errors.detailNotFound')}
      extra={
        <Button type="primary" onClick={() => void navigate(backTo)}>
          {t('common.buttons.backToList')}
        </Button>
      }
    />
  )
}
